import React, { ReactNode } from 'react';
import InputLabel from '@mui/material/InputLabel';
import Slider, { SliderTypeMap } from '@mui/material/Slider';
import Constants from 'style/constants';

import styles from './sonevo-slider.module.scss';

type Props = SliderTypeMap['props'] & {
  label: string;
  disabled: boolean;
  sliderIconStart: ReactNode;
  sliderIconEnd: ReactNode;
  minValue: number;
  maxValue: number;
  sliderMarks: { value: number; label?: string }[];
};

export const SonevoSlider = ({
  label,
  sliderIconStart,
  sliderIconEnd,
  disabled,
  sliderMarks,
  minValue,
  maxValue,
  ...sliderProps
}: Props): React.JSX.Element => (
  <div className={styles.sliderColumn}>
    <InputLabel>{label}</InputLabel>
    <div className={styles.sliderRow}>
      {sliderIconStart}
      <Slider
        {...sliderProps}
        sx={{
          '& .MuiSlider-valueLabel': {
            backgroundColor: Constants.Colors.primaryContainer,
            color: Constants.Colors.onPrimaryContainer,
          },
        }}
        valueLabelDisplay="auto"
        shiftStep={1}
        step={1}
        marks={sliderMarks}
        min={minValue}
        max={maxValue}
        disabled={disabled}
      />
      {sliderIconEnd}
    </div>
  </div>
);

export default SonevoSlider;
